import React, { useContext, useEffect, useMemo, useState } from "react";

import { LS_DIALER_LIVE_CALLS_PER_PAGE } from "const/localStorageKeys";
import { renderColumn } from "utils/helpers";
import FormHOC from "hoc/FilltersForm";
import CustomizableTable from "components/client/CustomizableTable/CustomizableTable";
import { RtlContext } from "../../App";


export default FormHOC(({
    data,
    loading,
    count,
    page,
    perPage,
    pickedColumns,
    savedTableColumns,
    getItems,
    onSaveColumnsTable,
    ...props
}) => {

    const selectedColumns = useMemo(() => {
        return Array.isArray(savedTableColumns)
            ? pickedColumns.filter(elem => savedTableColumns.includes(elem.id))
            : pickedColumns;
    }, [pickedColumns, savedTableColumns]);

    const [columns, onChangeColumns] = useState(selectedColumns);
    const rtl = useContext(RtlContext);

    useEffect(() => {
        onChangeColumns(selectedColumns);
    }, [selectedColumns]);

    const renderedColumns = columns.map(renderColumn);
    return (
        <CustomizableTable
            {...{
                rtl,
                data,
                count,
                page,
                perPage,
                loading,
                pickedColumns,
                getItems,
                renderedColumns,
                onChangeColumns,
                onSaveColumnsTable,
                savedTableColumns,
                ...props
            }}
            isChangedColumns={true}
            isPaginated={true}
            perPageLSKey={LS_DIALER_LIVE_CALLS_PER_PAGE}
            rowClassName={rowData => {
                if (rowData && rowData.is_test_call) {
                    return "rs-table-row rs-table-row--test-call-highlighted";
                }

                return "";
            }}
        />
    );
});

